import { useState, useCallback } from "react";

import { useMutation } from "@apollo/client";

import Mutation from "./Mutation.js";

export default function useSave(node) {
  const [error, setError] = useState();
  const [success, setSuccess] = useState();

  const mutation = useMutation(Mutation, {
    update: (cache) => {
      cache.modify({
        id: `Page:${node.id}`,
        fields: {
          [`bookingSeats({"type":"LEFT"})`]: function (c) {
            return c - 1;
          },
        },
      });
    },
    onCompleted: ({ purchase }) => {
      if (purchase.success) {
        setError(false);
        setSuccess(true);
      } else {
        setError(
          purchase.errorMessage || "There was an error with your purchase."
        );
        setSuccess(false);
      }
    },
    onError: (res) => {
      setError(res?.message || "There was an error with your purchase.");
      setSuccess(false);
    },
  });

  const onCompleted = useCallback(
    ({ input }) => {
      mutation[0]({
        variables: {
          input: {
            ...input,
            date: node.date,
            training_date: node.bookingDateFormatted,
            post_id: `${node.databaseId}`,
            clientMutationId: new Date().toString(32),
          },
        },
      });
    },
    [mutation, node]
  );

  return { error, setError, success, setSuccess, mutation, onCompleted };
}
